import { customAlphabet } from 'nanoid';

import type { SafeString } from '@fragment/types/strings';

const alphabet =
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const lilId = customAlphabet(alphabet, 21) as () => SafeString;
export default () => lilId();
